import { AGENCY_BUNDLE_ID } from './AgencyBundleProducts';

export const productPrices = [
	{
		name: 'Essential Addons',
		4372: {
			1: { basePrice: 59.99, dealPrice: 47.99 },
			3: { basePrice: 119.99, dealPrice: 77.88 },
			4: { basePrice: 299.99, dealPrice: 179.99 },
		},
	},
	{
		name: 'NotificationX',
		99658: {
			1: { basePrice: 49, dealPrice: 39 },
			3: { basePrice: 199, dealPrice: 149 },
			4: { basePrice: 399, dealPrice: 249 },
		},
	},
	{
		name: 'BetterDocs',
		342422: {
			1: { basePrice: 69, dealPrice: 55 },
			2: { basePrice: 149, dealPrice: 112 },
			3: { basePrice: 299, dealPrice: 199 },
		},
	},
	{
		name: 'SchedulePress',
		78593: {
			1: { basePrice: 49, dealPrice: 39 },
			3: { basePrice: 149, dealPrice: 112 },
			4: { basePrice: 399, dealPrice: 249 },
		},
	},
	{
		name: 'EmbedPress',
		414494: {
			1: { basePrice: 69, dealPrice: 55 },
			2: { basePrice: 199, dealPrice: 149 },
			3: { basePrice: 399, dealPrice: 249 },
		},
	},
	{
		name: 'BetterLinks',
		764539: {
			1: { basePrice: 99, dealPrice: 79 },
			2: { basePrice: 249, dealPrice: 187 },
			3: { basePrice: 399, dealPrice: 279 },
		},
	},
	{
		name: 'Better Payment',
		1738966: {
			1: { basePrice: 59, dealPrice: 47 },
			2: { basePrice: 199, dealPrice: 149 },
			3: { basePrice: 499, dealPrice: 349 },
		},
	},
	{
		name: 'Essential Blocks',
		1677666: {
			1: { basePrice: 49, dealPrice: 39 },
			2: { basePrice: 149, dealPrice: 112 },
			3: { basePrice: 349, dealPrice: 199 },
			6: { basePrice: 399, dealPrice: 249 },
		},
	},
	{
		name: 'Agency Bundle',
		[AGENCY_BUNDLE_ID]: {
			1: { basePrice: 399, dealPrice: 299 },
			2: { basePrice: 999, dealPrice: 699 },
			5: { basePrice: 29 },
		},
	},
];

export function getProductPrice(
	downloadId,
	priceId,
	lookingFor = 'basePrice',
	isMonthly = false
) {
	const product = productPrices.find(item => item[downloadId]);
	if (product) {
		const price = product[downloadId][priceId];
		if (price) {
			if (isMonthly && price?.[lookingFor]) {
				return Math.trunc((price[lookingFor] / 12) * 100, 2) / 100;
			}

			return price[lookingFor];
		}
	}
	return null;
}
